"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AirConditioningSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<circle cx="16" cy="16" r="1"/><path d="M16 8a8 8 0 108 8 8 8 0 00-8-8zm5.5 9.8a4.7 4.7 0 01-2.5.9 4.5 4.5 0 01-3-1.3 2.3 2.3 0 00-.1 3 1 1 0 01-.3 1.4 1 1 0 01-.6.2 1 1 0 01-.8-.5 4.4 4.4 0 01.4-5.6 2.4 2.4 0 00-3 0 1 1 0 11-1.1-1.7 4.4 4.4 0 015.6.4 2.4 2.4 0 00.1-3 1 1 0 011.7-1.1 4.4 4.4 0 01-.4 5.6 2.4 2.4 0 003 .1 1 1 0 011.3.3 1 1 0 01-.3 1.3z"/><path d="M28 2H4a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2zM16 26a10 10 0 1110-10 10 10 0 01-10 10z"/>';
var AirConditioningSVG = function AirConditioningSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.AirConditioningSVG = AirConditioningSVG;
AirConditioningSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(AirConditioningSVG);
exports.default = _default;